import { createClient } from '@supabase/supabase-js'
import type { Database } from '../types/supabase'
import { ENV } from '../constants/env'

export const supabase = ENV.SUPABASE_URL && ENV.SUPABASE_ANON_KEY
  ? createClient<Database>(ENV.SUPABASE_URL, ENV.SUPABASE_ANON_KEY)
  : null

export const isSupabaseConfigured = (): boolean => {
  return supabase !== null
}

export const EMAILS_TABLE = ENV.SUPABASE_EMAILS_TABLE
